import type {RenderMapEntity} from "@ots-frontend/ots-ui-tw";
import {EntityAnchor} from "../../../anchor/EntityAnchor/EntityAnchor";

/** Links a map panel's entities to their profiles, at the size of the text around them. */
export const renderMapEntityAnchor: RenderMapEntity = ({id, name, type}) => (
  <EntityAnchor
    spacing={4}
    noWrap
    sx={{display: "inline-flex", verticalAlign: "baseline"}}
    textProps={{fz: "inherit", fw: "inherit"}}
    value={{objectId: id, objectName: name, objectType: type}}/>
);
